
import './App.css';
import Dictionary from "./Dictionary";

function App() {
  return (
    <div className="App">
      <div className="container">
 <header className = "App-header"></header>
  <main>
    <Dictionary defaultKeyword="hello"/>
  </main>
  
  <footer className="App-footer">
    <small>Coded by Isha Fazli and is open sourced on
    <a rel='noreferrer' 
    href="https://github.com/IshaFazli3/dictionary/tree/main"> Github</a></small></footer>
    </div>
    
    </div>
  );
}

export default App;
